import { useQuery } from "@tanstack/react-query";
import {
  getAgentRunConversation,
  getAgentRunDetail,
  listAgentRuns,
  listAgents,
} from "../agents";

export function useAgentRunList(limit = 100) {
  return useQuery({
    queryKey: ["agents", "runs", { limit }],
    queryFn: () => listAgentRuns(limit),
  });
}

export function useAgentCatalog() {
  return useQuery({
    queryKey: ["agents", "catalog"],
    queryFn: () => listAgents(),
    staleTime: 5 * 60 * 1000, // catalog is essentially static
  });
}

export function useAgentRunDetail(runUuid: string | null) {
  return useQuery({
    queryKey: ["agents", "run", "detail", runUuid],
    queryFn: () => getAgentRunDetail(runUuid as string),
    enabled: !!runUuid,
  });
}

export function useAgentRunConversation(runUuid: string | null) {
  return useQuery({
    queryKey: ["agents", "run", "conversation", runUuid],
    queryFn: () => getAgentRunConversation(runUuid as string),
    enabled: !!runUuid,
  });
}
